"use client";

import { Button } from "@itzme1on/uikit";
import Link from "next/link";
import FluxVPNLogo from "../Icons/Logos/FluxVPNLogo";
import Navbar from "./Navbar/Navbar";

export default function Header() {
	return (
		<header className="fixed top-0 left-0 w-full right-0">
			<div className="relative bg-background/40 backdrop-blur px-4 py-3">
				<div className="grid grid-cols-[1fr_auto_1fr] items-center max-w-site mx-auto">
					<div className="justify-self-start">
						<Link
							href="/"
							className="flex flex-row items-center gap-2.5 hover:text-front select-none group/logo transition-colors"
						>
							<FluxVPNLogo
								size={32}
								className="text-primary transition-colors group-hover/logo:text-primary-accent-hover"
							/>

							<h1 className="text-xl font-bold transition-colors group-hover/logo:text-primary-accent-hover">
								FluxVPN
							</h1>
						</Link>
					</div>

					<div>
						<Navbar />
					</div>

					<div className="justify-self-end">
						<Link href="/cabinet">
							<Button type="primary">Войти</Button>
						</Link>
					</div>
				</div>
			</div>
		</header>
	);
}
